import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { StatusMessageHelper } from '../../Utils/StatusMessageHelper';

var FILTER_DELIM = '-delim-';
var tableId = 'tableGameBuildConfigurations';
var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface IndexPageOptions extends PageOptionsBase {
    urlList: string;
    urlUpdate: string;
}

export class IndexPage extends PageBase<IndexPageOptions> {

    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _filterGame: MultiSelectApi;
    private _filterCustomer: MultiSelectApi;
    private _filterCustomerOperation: MultiSelectApi;
    private _form: JQuery;
    private _btnCancelSearch: JQuery;

    constructor(options: IndexPageOptions) {
        super(options);
        this.preDrawCallback = this.preDrawCallback.bind(this);
        this.formSubmit = this.formSubmit.bind(this);
        this.cancelSearch = this.cancelSearch.bind(this);
        this.clientVersionChanged = this.clientVersionChanged.bind(this);

        window['clientVersionChanged'] = this.clientVersionChanged;

        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'GameId',
            columns: [
                {
                    sortable: false,
                    data: 'Customer'
                },
                {
                    sortable: false,
                    data: 'CustomerOperation'
                },
                {
                    sortable: false,
                    data: 'GameName'
                },
                {
                    sortable: false,
                    data: 'GameClientVersionNumber',
                    render: (data: any, type: any, rowData: any) => {
                        let value = Utils.isNullOrUndefined(rowData.GameClientVersionNumber) ? "" : rowData.GameClientVersionNumber;
                        return (`<input id='gameVersion${rowData.GameId}' name='gameVersion' value='${value}' />
                        <input class='btn' id='btnUpdateVersion${rowData.GameId}' value='Save' type='button' onclick='clientVersionChanged(${rowData.GameId}, ${rowData.CustomerOperationId})' />`);
                    }
                },
                {
                    sortable: false,
                    data: 'Modified',
                    render: (data: any, type: any, rowData: any) => {
                        return Utils.isNullOrUndefined(data) ? 'Not modified' : data;
                    }
                }
            ],
            callbacks: {
                preDrawCallback: this.preDrawCallback
            }
        };
    }

    init(): void {
        this._form = Utils.getJQueryById("formGameClientVersions");
        this._btnCancelSearch = Utils.getJQueryById("btnCancelSearch");
        this._filterGame = new MultiSelectApi('filterGame');
        this._filterCustomer = new MultiSelectApi('filterCustomer');
        this._filterCustomerOperation = new MultiSelectApi('filterCustomerOperation');
        this._table = new Datatable(tableId, this._tableOptions);
        this._form.on('submit', this.formSubmit);
        this._btnCancelSearch.on('click', this.cancelSearch);
    }

    private formSubmit(e: JQueryEventObject): any {
        e.preventDefault();
        this._table.draw();
        return false;
    }

    private preDrawCallback(datatable: DatatableApi): any {
        var filterCustomer = this._filterCustomer.isAllSelected() ? '' : this._filterCustomer.getSelectionValues(FILTER_DELIM);
        datatable.columns(0).search(filterCustomer);
        var filterCustomerOperation = this._filterCustomerOperation.isAllSelected() ? '' : this._filterCustomerOperation.getSelectionValues(FILTER_DELIM);
        datatable.columns(1).search(filterCustomerOperation);
        var filterGame = this._filterGame.isAllSelected() ? '' : this._filterGame.getSelectionValues(FILTER_DELIM);
        datatable.columns(2).search(filterGame);
        return true;
    }

    private cancelSearch(e: JQueryEventObject): void {
        this._filterGame.selectAll();
    }

    private clientVersionChanged(gameId: number, operationId: number) {
        let gameVersion = (document.getElementById(`gameVersion${gameId}`) as HTMLInputElement).value;
        let urlUpdate = this._options.urlUpdate;
        let table = this._table;
        var statusMessage = Utils.getJQueryById("statusMessageWrapper");
        $.ajax({
            url: urlUpdate,
            type: "POST",
            data: {
                customerOperationId: operationId,
                gameId: gameId,
                version: gameVersion
            },
            success: function (data) {
                statusMessage.html(data);
                StatusMessageHelper.initValidator();
                StatusMessageHelper.initSatusMessage();
                table.draw(false);
            }
        });
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/GameClientVersions/IndexPage.ts
 **/